import { AppBar, BottomNavigation, BottomNavigationAction, Icon, Paper, Toolbar, Typography, withStyles } from '@material-ui/core';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Routes } from '../navigation/RootNavigator';
import Button from './Button';
import Container from './Container';
import Logo from './Logo';

class _Toolbar extends React.PureComponent {

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))


    handleChange = (route) => {
        if (this.props.match.path !== route)
            this.props.history.push(route)
    }

    getCurrentRoute = () => {
        const match = this.props.match.path.match(/(\/\w+).*?/)
        return match ? match[1] : this.props.match.path
    }

    renderToolbarButton = (value, label) => {
        const currentRoute = this.getCurrentRoute()

        return (
            <Button
                className={this.props.classes.toolbarButton}
                onClick={() => this.handleChange(value)}
                variant={value === currentRoute ? 'contained' : 'text'}
                color={value === currentRoute ? 'secondary' : 'default'}>
                <Typography className={cn(
                    this.props.classes.button,
                    { [this.props.classes.buttonLight]: value === currentRoute || !this.props.light }
                )}>{label}</Typography>
            </Button>
        )
    }

    render() {

        const { classes, light, elevated } = this.props

        const currentRoute = this.getCurrentRoute()

        return (
            <AppBar position="fixed_"
                color={light ? 'inherit' : 'primary'}
                className={cn(classes.appBar, { [classes.appBarElevated]: elevated })}
                elevation={elevated ? 2 : 0}>
                <Container>
                    <Toolbar className={classes.toolbar}>
                        <Logo className={classes.icon} onClick={() => this.handleChange(Routes.HOME)} />
                        <Typography variant="title" color="inherit"
                            className={cn(classes.title, { [classes.titleLight]: light })}>
                            Cytech
                        </Typography>

                        {false && this.renderToolbarButton(Routes.HOME, 'Início')}
                        {false && this.renderToolbarButton(Routes.SOLUTIONS, 'Soluções Pra Você')}
                        {false && this.renderToolbarButton(Routes.WORKS, 'Nossos Produtos')}
                        {false && this.renderToolbarButton(Routes.CONTACT, 'Contato')}

                    </Toolbar>
                    {
                        false && (
                            <Paper className={classes.bottonNavigation} elevation={4}>
                                <BottomNavigation value={currentRoute}
                                    onChange={(_, value) => this.handleChange(value)}>
                                    <BottomNavigationAction label="Início" value={Routes.HOME} icon={<Icon>home</Icon>} />
                                    <BottomNavigationAction label="Soluções" value={Routes.SOLUTIONS} icon={<Icon>wb_incandescent</Icon>} />
                                    <BottomNavigationAction label="Produtos" value={Routes.WORKS} icon={<Icon>layers</Icon>} />
                                    <BottomNavigationAction label="Início" value={Routes.CONTACT} icon={<Icon>phone</Icon>} />
                                </BottomNavigation>
                            </Paper>
                        )
                    }
                </Container>
            </AppBar>
        )
    }

}

_Toolbar.propTypes = {
    classes: PropTypes.any,
    light: PropTypes.bool,
    elevated: PropTypes.bool
}

const styles = theme => ({
    appBar: {
        position: 'absolute',
        top: 0,
        transition: `all 300ms ${theme.transitions.easing.material}`,
        backgroundColor: 'transparent'
    },
    appBarElevated: {

    },
    toolbar: {
        width: '100%',
        padding: 0,
    },
    toolbarButton: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        marginLeft: 16,
    },
    bottonNavigation: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    button: {
        fontWeight: '500',
        color: theme.palette.grey['800'],
    },
    buttonLight: {
        fontWeight: '500',
        color: theme.palette.secondary.contrastText
    },
    icon: {
        width: 64,
        height: 64,
        marginRight: 16,
        cursor: 'pointer'
    },
    title: {
        flex: 1,
        color: theme.palette.primary.main,
        fontFamily: 'Montserrat',
        fontWeight: 700,
        letterSpacing: 1.5
    },
    titleLight: {
        color: theme.palette.black,
        fontFamily: 'Montserrat'
    }
})

export default withRouter(withStyles(styles)(_Toolbar))


// WEBPACK FOOTER //
// ./src/components/common/Toolbar.js